import { supabase } from '../lib/supabase';

export const serviceTypeService = {
  // Get all service types with optional filters
  async getAllServiceTypes(filters = {}) {
    try {
      let query = supabase?.from('service_types')?.select('*')?.order('name', { ascending: true });

      // Apply filters
      if (filters?.search) {
        query = query?.or(`name.ilike.%${filters?.search}%,display_name.ilike.%${filters?.search}%,description.ilike.%${filters?.search}%`);
      }

      const { data, error } = await query;
      if (error) throw error;

      return { data, error: null };
    } catch (error) {
      console.error('Error fetching service types:', error);
      return { data: null, error };
    }
  },

  // Get service type by ID
  async getServiceTypeById(id) {
    try {
      const { data, error } = await supabase?.from('service_types')?.select('*')?.eq('id', id)?.single();

      if (error) throw error;

      return { data, error: null };
    } catch (error) {
      console.error('Error fetching service type:', error);
      return { data: null, error };
    }
  },

  // Create new service type
  async createServiceType(serviceTypeData) {
    try {
      const { data, error } = await supabase?.from('service_types')?.insert(serviceTypeData)?.select()?.single();

      if (error) throw error;

      return { data, error: null };
    } catch (error) {
      console.error('Error creating service type:', error);
      return { data: null, error };
    }
  },

  // Update service type
  async updateServiceType(id, serviceTypeData) {
    try {
      const { data, error } = await supabase?.from('service_types')?.update(serviceTypeData)?.eq('id', id)?.select()?.single();

      if (error) throw error;

      return { data, error: null };
    } catch (error) {
      console.error('Error updating service type:', error);
      return { data: null, error };
    }
  },

  // Delete service type
  async deleteServiceType(id) {
    try {
      const { error } = await supabase?.from('service_types')?.delete()?.eq('id', id);

      if (error) throw error;

      return { data: true, error: null };
    } catch (error) {
      console.error('Error deleting service type:', error);
      return { data: null, error };
    }
  },

    // Get service types for dropdown/select components
  async getServiceTypeOptions(filters = {}) {
    try {
      // If dealership_id provided, prefer dealership-specific pricing by joining pricing table
      const dealershipId = filters?.dealership_id || filters?.car_house_id;

      if (dealershipId) {
        // Use the dealership_service_pricing_view for accurate pricing
        const { data, error } = await supabase
          ?.from('dealership_service_pricing_view')
          ?.select(`
            service_type_id,
            service_type_display_name,
            final_price,
            dealership_price,
            default_price,
            pricing_type
          `)
          ?.eq('dealership_id', dealershipId)
          ?.eq('service_type_active', true)
          ?.order('service_type_display_name', { ascending: true });

        if (error) throw error;

        const options = (data || []).map(item => ({
          value: item.service_type_id,
          label: item.service_type_display_name,
          price: item.final_price,
          pricing_type: item.pricing_type,
          dealership_price: item.dealership_price,
          default_price: item.default_price
        }));

        return { data: options, error: null };
      }

      // Fallback: global options
      const { data, error } = await this.getAllServiceTypes({ ...filters, is_active: true });

      if (error) throw error;

      const options = data?.map(serviceType => ({
        value: serviceType.id,
        label: serviceType.display_name,
        price: serviceType.price
      })) || [];

      return { data: options, error: null };
    } catch (error) {
      console.error('Error fetching service type options:', error);
      return { data: [], error };
    }
  },



  // Validate service type data
  validateServiceTypeData(data) {
    const errors = {};

    if (!data?.name?.trim()) {
      errors.name = 'Name ist erforderlich';
    } else if (!/^[a-z_]+$/.test(data.name)) {
      errors.name = 'Name darf nur Kleinbuchstaben und Unterstriche enthalten';
    }

    if (!data?.display_name?.trim()) {
      errors.display_name = 'Anzeigename ist erforderlich';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  },

  // Get default service type data for new entries
  getDefaultServiceTypeData() {
    return {
      name: '',
      display_name: '',
      description: '',
      price: 0.00
    };
  }
};
